import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Stage an Ask Redo return-flow working copy into the flow editor as
 * unpublished changes — the preview modal's Edit path, no publish.
 */
export const stageAskRedoReturnFlowDraft = {
  name: "stageAskRedoReturnFlowDraft" as const,
  input: z.object({
    threadId: zExt.objectId(),
    draftId: z.string(),
    toolCallId: z.string(),
  }),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal("saved"),
      result: z.object({
        kind: z.literal("return-flow-staged"),
        flowType: z.literal("return"),
        status: z.literal("saved"),
        draftId: z.string(),
        message: z.string(),
      }),
    }),
    z.object({ status: z.literal("failed") }),
  ]),
};
